const smallFunctionListLayouts = [
	{
		value: "3x5",
		row: 5,
		col: 3,
	},
];

export default smallFunctionListLayouts;
